import { createContext, useContext, type ReactNode } from 'react';
import type { MarketLinkAction } from '../hooks/useMarketModal';
import type { DepartmentMetadata } from '../models';

export interface MarketContextValue {
  pendingMarketAction: MarketLinkAction | null;
  clearMarketAction: () => void;
  onMarketLinkCompleted: (marketCode: number, actionType: 'connect' | 'disconnect') => void;
  onSelectedMarketsChanged: (selectedMarkets: DepartmentMetadata['selectedMarkets']) => void;
  connectedMarketCodes: Set<number>;
  disconnectedMarketCodes: Set<number>;
  mainMarketCode: number;
  departmentMetadata: DepartmentMetadata;
}

const MarketContext = createContext<MarketContextValue | null>(null);

export function MarketContextProvider({
  children,
  value,
}: Readonly<{ children: ReactNode; value: MarketContextValue }>) {
  return <MarketContext.Provider value={value}>{children}</MarketContext.Provider>;
}

export function useMarketContext(): MarketContextValue {
  const ctx = useContext(MarketContext);
  if (!ctx) throw new Error('useMarketContext must be used within MarketContextProvider');
  return ctx;
}
